import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";
import {Link} from "react-router-dom";

function Block0() {

    return (
            <section className="banner-section">
                <div className="auto-container">
                    <div className="row">
                        <div className="content-column col-lg-7 col-md-12 col-sm-12">
                            <div className="sec-title-outer layout-pt-60">
                                <div className="sec-title" style={{color: "#ffffff"}}>
                                    <Link to="/" title="Accueil webinaires Talents Handicap">
                                        <img src="/images/webinaires-TH-1.png" alt="Webinaires Talents Handicap" width={"250px"}
                                             className="homepage"/>
                                    </Link>
                                    <h2 className="homepage mt-20">Sensibilisez et faites progresser vos équipes
                                        sur <span>le handicap et l’inclusion</span></h2>


                                    <div className="text mt-30">
                                        Une série de webinaires clés en main, organisés sur un espace web dédié à votre
                                        entreprise, pour transformer vos collaborateurs en acteurs de l’inclusion.
                                        <ul className="list-style-one homepage black mt-3">
                                            <li>Webinaires animés par des experts Talents Handicap</li>
                                            <li>Plateforme personnalisée à vos couleurs</li>
                                            <li>Replay + Livret « L'essentiel à retenir » +  ressources pédagogiques</li>
                                            <li>Kit de communication complet</li>
                                            <li>Statistiques détaillées de participation et de satisfaction
                                            </li>
                                        </ul>
                                    </div>
                                    <ContactModal textButton="Demander une présentation personnalisée" showText={false}
                                                  small="small" linkPageContact={false} iframe={false} couleur={false}
                                                  formModal={true}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-5 col-md-12 layout-pt-60">
                            <div className="d-flex justify-content-end">
                            <ContactModal textButton="Contactez-nous" showText={false}
                                          small="small" linkPageContact={false} iframe={false} couleur={false}
                                          formModal={true}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Block0;
